import Vue from 'vue'
import VueMask from 'v-mask'

Vue.use(VueMask, {
  placeholders: {
    '#': null, // passing `null` removes default placeholder, so `#` is treated as character
    N: /[0-9]/, // define new placeholder
  },
})
